module.exports = __webpack_public_path__ + "img/ElenaSchatz_140x140.35e97683.jpg";